import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";

export const ProspectNotifyButton = () => {
  const [joined, setJoined] = useState(null);
  useEffect(() => { api.get("/prospect/notify-me").then((r) => setJoined(r.data.joined)).catch(() => setJoined(false)); }, []);
  const toggle = async () => {
    try {
      const r = joined ? await api.delete("/prospect/notify-me") : await api.post("/prospect/notify-me");
      setJoined(r.data.joined);
      toast.success(r.data.joined ? "You're on the list — we'll message you when new dates & prices open" : "Removed from the notify list");
    } catch (e) { toast.error(apiErr(e)); }
  };
  if (joined === null) return null;
  return (
    <Button type="button" size="sm" variant="outline" onClick={toggle} data-testid="prospect-notify-btn"
      className={`rounded-full mt-2 ${joined ? "border-turquoise text-navy" : "border-gold text-navy"}`}>
      {joined ? <BellOff className="w-3.5 h-3.5 mr-1" /> : <Bell className="w-3.5 h-3.5 mr-1" />}
      {joined ? "On the list · tap to leave" : "Notify me when new dates open"}
    </Button>
  );
};
